import { toast } from "@/components/Toast";
import config from "@/config";
import { BaseResponse } from "@/types/base";
import Axios from "@/utils/Axios";
import { Editor_Words } from "@/utils/lang/editor";
import { langStore, translate } from "@noli/business";

export const API_Img2Prompt = "/img2prompt";

export interface postImg2PromptRequestData {
  image_url: string;
  style: string;
}
export const postImg2Prompt = ({ image_url, style }: postImg2PromptRequestData) => {
  return Axios.post<postImg2PromptRequestData, BaseResponse<{ prompt: string }>>(
    API_Img2Prompt,
    {
      image_url,
      style,
    },
    {},
    config.creatorUrl,
  )
    .then((res) => res)
    .then((res) => {
      if (res.code === 0 && res.data) {
        return res.data.prompt;
      }
      if (res.code === 0 && !res.data) {
        toast({
          title: res?.msg ?? translate(Editor_Words["img2promopt_failed_message"], langStore.tgt),
          status: "error",
        });
      }
      return Promise.reject(res);
    });
};
